import type { MessageView } from "./api/types";
import { useCharacter } from "./character";
import { sheetTabsFor, systemUi } from "./registry";

/**
 * Where a message leads, relative to the character: its assistant step in creation mode, otherwise the sheet tab of the current mode that
 * shows its subject; undefined when there is no such place.
 */
export function useMessagePlace(): (m: MessageView) => string | undefined {
  const { character, system } = useCharacter();
  const steps = new Set((system?.wizardSteps ?? []).map((s) => s.id));
  const tabs = new Set(sheetTabsFor(systemUi(character.system), character.mode).map((t) => t.id));
  return (m) => {
    const step = m.message.target?.step;
    if (character.mode === "creation" && step && steps.has(step)) return `assistent/${step}`;
    const tab = m.message.target?.tab;
    return tab && tabs.has(tab) ? `bogen/${tab}` : undefined;
  };
}
